import {AEntity} from "./abstract/AEntity";

export interface IDomaine {
    dirLib: string
    domLib: string
    domLibLong: string
    domDesc: string
    domOrdre?: number
}

export class Domaine extends AEntity {
    dirLib: string
    domLib: string
    domLibLong: string
    domDesc: string
    domOrdre: number

    constructor(domaine: IDomaine) {
        super();
        this.dirLib = domaine.dirLib;
        this.domLib = domaine.domLib;
        this.domLibLong = domaine.domLibLong;
        this.domDesc = domaine.domDesc;
        this.domOrdre = domaine.domOrdre ?? 0;
    }

    getId(): string {
        return `${this.dirLib}|${this.domLib}`;
    }

    toJSON(): IDomaine {
        return {
            dirLib: this.dirLib,
            domLib: this.domLib,
            domLibLong: this.domLibLong,
            domDesc: this.domDesc,
            domOrdre: this.domOrdre,
        }
    }
}
